import axiosWithCredentials from "@/libs/apis/commons";
import { GET_TOKEN_TRANSFER_STATUS_URL } from "../constants";
import { TokenTransferStatusResponseBody } from "../types";

export const tokenTransferStatusForId = async (transactionId: string) => {
  return await axiosWithCredentials
    .get(GET_TOKEN_TRANSFER_STATUS_URL(transactionId))
    .then(({ data }: { data: TokenTransferStatusResponseBody }) => data);
};
